import type {
    ClassicalListItem,
    ClassicalListViewPage,
} from '@jet-app/music-classical/api/types';
import type { Section } from '@jet-app/music-classical/models/section/Section';
import { makeOnListItemClickAction } from '@jet-app/music-classical/action-model/onListItemClickAction';
import { fixArtwork } from '@jet-app/music-classical/models';

export const transformListView = (
    listViewPage: ClassicalListViewPage,
): Section<unknown> => {
    const items = listViewPage.firstPage?.items || [];

    return {
        id: `list-view-${listViewPage.title}`,
        sectionKind: 'list-view',
        items: items.map((item: ClassicalListItem) => ({
            ...getListViewItem(item),
            artwork: fixArtwork(item.image),
            clickAction: makeOnListItemClickAction(item.id, item.type),
        })),
        itemKind: items[0] ? (items[0] as any).type : undefined,
        pageMetadata: {
            total: listViewPage?.firstPage?.total,
            page: listViewPage?.firstPage?.page,
            next: listViewPage?.firstPage?.next,
        },
    };
};

export function getListViewItem(item: ClassicalListItem) {
    switch (item.type) {
        case 'work':
            return {
                ...item,
                subtitle: item.opusAndAltTitle,
                heading: item.composerName,
            };

        default:
            return item;
    }
}
